
export const UrlMatching: { [key: string]: { [action: string]: string[] } } = {        
    "/api/account/personal/account" : {"POST" : ["저장", "개인 계좌이체거래약정서 발급 신청"]},
    "/api/account/company/account" : {"POST" : ["저장", "법인 계좌이체거래약정서 발급 신청"]},
    "/api/account/account/docs" : {"POST" : ["조회","계좌이체거래약정 pdf 가져오기"]} ,
    "/api/account/personal/account/main/:id" : {"PATCH" : ["조회", "개인 계좌이체거래약정 pdf 불러오기"]},
    "/api/account/company/account/main/:id" : {"PATCH" : ["조회","법인 계좌이체거래약정 pdf 불러오기"]},
    "/api/account/personal/account-check" : {"POST" : ["조회", "개인 유효성검사(계좌 소유주 확인)" ]},
    "/api/account/company/account-check" : {"POST" : ["조회", "법인 유효성검사(계좌 소유주 확인)"]},
    "/api/account/personal/emp" : {"GET" : ["조회", "담당자 찾기"], "PATCH" : ["수정","담당자 변경" ]},
    "/api/account/consignment/emp" : {"GET" : ["조회", "담당자 찾기"], "PATCH" : ["수정","담당자 변경" ]},
    "/api/account/security/emp" : {"GET" : ["조회", "담당자 찾기"], "PATCH" : ["수정","담당자 변경" ]},
    "/api/account/agreement/emp" : {"GET" : ["조회", "담당자 찾기"], "PATCH" : ["수정","담당자 변경" ]},
    "/api/account/company/emp" : {"GET" : ["조회", "담당자 찾기"], "PATCH" : ["수정","담당자 변경" ]},
    "/api/account/committer/emp" : {"GET" : ["조회", "담당자 찾기"], "PATCH" : ["수정","담당자 변경" ]},
    "/api/account/personal/emp/:id" : {"GET" : ["조회", "특정 담당자 정보 가져오기"]},
    "/api/account/consignment/emp/:id" : {"GET" : ["조회", "특정 담당자 정보 가져오기"]},
    "/api/account/security/emp/:id" : {"GET" : ["조회", "특정 담당자 정보 가져오기"]},
    "/api/account/agreement/emp/:id" : {"GET" : ["조회", "특정 담당자 정보 가져오기"]},
    "/api/account/company/emp/:id" : {"GET" : ["조회", "특정 담당자 정보 가져오기"]},
    "/api/account/committer/emp/:id" : {"GET" : ["조회", "특정 담당자 정보 가져오기"]},
    "/api/account/auth/personal/signup" : {"POST" : ["저장", "개인 회원가입"]},
    "/api/account/auth/company/signup" : {"POST" : ["저장", "법인 회원가입"]},
    "/api/account/auth/username" : {"GET" : ["조회", "아이디 중복체크"]},
    "/api/account/auth/email" : {"GET" : ["조회","이메일 중복체크"]},
    "/api/account/auth/email/code" : {"POST" : ["저장","이메일 인증코드 보내기"]},
    "/api/account/auth/email/code/resend" : {"POST" :["저장", "이메일 코드 재전송"]},
    "/api/account/auth/email/verify" : {"GET" : ["저장", "이메일 인증"]},
    "/api/account/auth/duplicate" : {"POST" : ["조회", "유저 중복체크"]},
    "/api/account/auth/login" : {"POST" : ["조회", "유저 로그인"]},
    "/api/account/auth/login/:id" : {"POST" : ["저장", "2차 전화번호 인증"]},
    "/api/account/auth/login/otp" : {"POST" : ["조회", "관리자 OTP 로그인"]},
    "/api/account/auth/login/fido" : {"POST" : ["조회","관리자 지문 로그인"]},
    "/api/account/auth/logout" : {"POST" : ["삭제", "로그아웃"]},
    "/api/account/auth/user/refresh" : {"POST" : ["저장", "유저 토큰 재발급"]},
    "/api/account/auth/master/refresh" : {"POST" : ["저장", "관리자 토큰 재발급"]},
    "/api/account/auth/find" : {"POST" : ["조회", "아이디 찾기"]},
    "/api/account/auth/find/pw" : {"POST" : ["조회", "비밀번호 찾기"]},
    "/api/account/auth/pass" : {"POST" : ["저장","나이스 본인인증 신청"]},
    "/api/account/auth/pass/dec" : {"POST" : ["저장", "나이스 본인인증 요청 (데이터 전송)"]},
    "/api/account/auth/login/sso" : {"POST" : ["조회", "SSO 로그인"]},
    "/api/account/auth/change/phone" : {"POST" : ["저장","전화번호 변경 본인 확인 전화번호 인증"]},    
    "/api/account/auth/out" : {"POST" :["삭제", "계정 탈퇴"]},    
    "/api/account/dashboard/partner" : {"GET" : ["조회", "이용자 가입현황 정보 조회"]},    
    "/api/account/dashboard/account" : {"GET" : ["조회", "계좌이체약정서 발급 현황"]},    
    "/api/account/dashboard/account/list" : {"GET" : ["조회", "계좌이체거래약정서 신청 현황"]},    
    "/api/account/master/users" : {"GET" : ["조회", "이용자 리스트"]},    
    "/api/account/master/accounts" : {"GET" : ["조회", "계좌이체거래약정서 리스트"]},    
    "/api/account/master/accounts/success/user" : {"GET" : ["조회", "이용자 리스트"]},    
    "/api/account/master/accounts/user/:id" : {"GET" : ["조회","특정 User에 발급된 모든 계좌이체거래약정서"]},    
    "/api/account/personal/account/list" : {"GET" : ["조회", "개인 계좌이체거래약정서 리스트 가져오기"]},    
    "/api/account/company/account/list" : {"GET" : ["조회", "법인 계좌이체거래약정서 리스트 가져오기"]},    
    "/api/account/master/user/apply/:id" : {"POST" : ["수정","User 가입 요청 승인"]},    
    "/api/account/master/user/reject/:id" : {"POST" : ["수정","User 가입 요청 반려"]},    
    "/api/account/master/user/:id" : {"GET" : ["조회","이용자 상세"]},
    "/api/account/master/account/:id" : {"GET" : ["조회","계좌거래약정서 상세"]},
    "/api/account/master/account/:id/approval" : {"PATCH" : ["수정", "계좌거래약정서 승인"]},
    "/api/account/master/account/:id/reject" : {"PATCH" : ["수정", "계좌거래약정서 반려"]},
    "/api/account/master/invite" : {"POST" : ["저장", "이용자 초대"]},
    "/api/account/term" : {"PATCH" : ["수정","약관 수정"],"GET" : ["조회", "약관 모두보기"]},
    "/api/account/term/personal" : {"GET" : ["조회", "약관 모두보기"]},
    "/api/account/term/personal_account" : {"GET" : ["조회", "계좌 이체용 약관 모두보기"]},
    "/api/account/term/company" : {"GET" : ["조회", "약관 모두보기"]},
    "/api/account/term/consignment" : {"GET" : ["조회", "약관 모두보기"]},
    "/api/account/term/security" : {"GET" : ["조회", "약관 모두보기"]},
    "/api/account/term/agreement" : {"GET" : ["조회", "약관 모두보기"]},
    "/api/account/term/committer" : {"GET" : ["조회", "약관 모두보기"]},
    "/api/account/resource" : {"GET" : ["다운로드","파일 경로" ]},
    "/api/account/master/accounts/check/:id/files" : {"GET" : ["조회", "회계담당자 계좌이체거래약정서 파일 가져오기"]},
    "/api/account/master/accounts/check/:id" : {"GET" : ["조회", "회계담당자 계좌이체거래약정서 파일 확인"]},
    "/api/account/qr/docs" : {"POST" : ["조회", "계좌이체거래약정서 PDF 데이터"]},
    "/api/account/qr/block" : {"POST" : ["조회", "블록체인 데이터"]},
    "/api/account/master/log/pass" : {"POST" : ["수정","로그 리스트 패스워드 변경"]},
    "/api/account/master/log/check" : {"POST" : ["조회","로그 리스트 패스워드 체크"]},
    "/api/account/master/log" : {"GET" : ["조회", "로그 리스트 호출"]},
    "/api/account/master/log/:id" : {"GET" : ["조회", "로그 리스트 상세"]},
    "/api/account/myinfo/:id" : {"GET" : ["조회", "내 정보 파일 목록"]},
    "/api/account/company/info/manager" : {"PATCH" : ["수정", "법인 담당자 정보 변경"]},
    "/api/account/company/info/email" : {"PATCH" : ["수정", "법인 이메일 변경"]},
    "/api/account/company/info/password" : {"PATCH" : ["수정", "법인 비밀번호 변경"]},
    "/api/account/company/me" : {"GET" : ["조회","법인 내 정보 조회"]},
    "/api/account/company/me/hisotry" : {"GET" : ["조회", "법인 내 정보 변경 내역"]},
    "/api/account/personal/info/phone" : {"PATCH" : ["수정","개인 전화번호 변경"]},
    "/api/account/personal/info/email" : {"PATCH" : ["수정","개인 이메일 변경"]},
    "/api/account/personal/info/password" : {"PATCH" : ["수정","개인 비밀번호 변경"]},
    "/api/account/personal/me" : {"GET" : ["조회","개인 내 정보 조회"]},
    "/api/account/personal/me/hisotry" : {"GET" : ["조회","개인 내 정보 변경 내역"]},
    "/api/account/manual" : {"GET" : ["다운로드", "매뉴얼 다운로드"]},








    


};

